import {
  pythonClient,
  openAiClient,
} from "../config/axios";
// import * as Sentry from "@sentry/react";
export const fetchChatGPT = async (params) => {
  // let parsedUser = null;
  let teacher_id = null;
  const localStorageUser = localStorage.getItem("user");
  if (localStorageUser) {
    const parsedUser = JSON.parse(localStorageUser);
    teacher_id = parsedUser.id;
  }
  const data = { ...params, teacher_id };
  try {
    const response = await pythonClient.post("/chatgpt", { ...data });
    return response.data;
  } catch (error) {
    // const errorMessage = `ChatGPT Legacy Service Error`;
    // Sentry.captureMessage(errorMessage, 'error');
    // Sentry.withScope((scope) => {
    //   scope.setTag("service_location", "chatService_fetchChatGPT");
    //   scope.setLevel("error");
    //   scope.setExtra("payload", data); // Optional: Add additional context
    //   if (localStorageUser) {
    //     scope.setUser({
    //       id: parsedUser?.id,
    //       email: parsedUser?.email,
    //       first_name: parsedUser?.first_name,
    //       last_name: parsedUser?.last_name,
    //     });
    //   }
    //   Sentry.captureException(error);
    // });
    throw error;
  }
};

export const fetchAssistantChatGPT = async (params) => {
  let parsedUser = null;
  let teacher_id = null;
  const localStorageUser = localStorage.getItem("user");
  if (localStorageUser) {
    parsedUser = JSON.parse(localStorageUser);
    teacher_id = parsedUser.id;
  }
  const data = { ...params, teacher_id };
  try {
    const response = await openAiClient.post("/interactions", { ...data });
    return response.data;
  } catch (error) {
    throw error;
  }
};
